import { cacheBustedUrl } from "./retry-import";

/**
 * Import an ES module by URL under a cache-busting query: the retry path for a chunk the browser has
 * already failed on (a failed `import()` is remembered per URL). Only reachable from a failure message
 * that names an ES module URL, i.e. the Vite-built embeds; the bundler must leave this call alone.
 */
export function importFromUrl<T>(url: string, attempt: number): Promise<T> {
  return import(
    /* @vite-ignore */ /* webpackIgnore: true */ /* turbopackIgnore: true */ cacheBustedUrl(
      url,
      // Unique per call: every URL the browser already failed on stays failed, a manual Retry
      // after the automatic ones must not reuse one.
      `${Date.now().toString(36)}-${attempt}`,
    )
  ) as Promise<T>;
}
